import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utilities';

const initialState = {
  showModal: false,
  modalType: null,
  error: false,
  drawerOpen: false,
  menuMouseTracker: false,
  showUserMenu: false,
  prevPath: null,
  currentPath: null
}

const toggleModal = (state) => {
  return updateObject(state, { showModal: !state.showModal })
}

const toggleDrawer = (state, action) => {
  let drawerOpen = false;
  switch (action.toggleAction) {
    case 'open': drawerOpen = true;
      break;
    case 'close': drawerOpen = false;
      break;
    default: drawerOpen = !state.drawerOpen;
  }
  return updateObject(state, { drawerOpen: drawerOpen })
}

const toggleMenuMouseTracker = (state, action) => {
  let trackerOn = false;
  switch (action.toggleAction) {
    case 'open': trackerOn = true;
      break;
    case 'close': trackerOn = false;
      break;
    default: trackerOn = false;
  }
  return updateObject(state, { menuMouseTracker: trackerOn })
}

const toggleUserMenu = (state, action) => {
  let menuOpen = false;
  switch (action.toggleAction) {
    case 'open': menuOpen = true;
      break;
    case 'close': menuOpen = false;
      break;
    default: menuOpen = !state.showUserMenu;
  }
  return updateObject(state, { showUserMenu: menuOpen })
}

const displayPageError = (state) => {
  return updateObject(state, { error: true });
}

const clearPageError = (state) => {
  return updateObject(state, { error: false });
}

const logCurrentPath = (state, action) => {
  return updateObject(state, { currentPath: action.path, prevPath: state.currentPath })
}

const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_MODAL: return toggleModal(state);
    case actionTypes.TOGGLE_DRAWER: return toggleDrawer(state, action);
    case actionTypes.DISPLAY_PAGE_ERROR: return displayPageError(state);
    case actionTypes.CLEAR_PAGE_ERROR: return clearPageError(state);
    case actionTypes.TOGGLE_MENU_MOUSE_TRACKER: return toggleMenuMouseTracker(state, action);
    case actionTypes.TOGLE_USER_MENU: return toggleUserMenu(state, action);
    case actionTypes.LOG_CURRENT_PATH: return logCurrentPath(state, action);
    default: return state;
  }
}

export default globalReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/globalReducer.jsx